import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@d-environments/environment';
import { login } from '@d-store/auth';
import { v4 as uuid } from 'uuid';
@Injectable()
export class AzureSSOService {
  constructor(private httpClient: HttpClient) {}

  async generateSSOUrl(email) {
    const url = `${environment.azureSSO.authority}/oauth2/v2.0/authorize`;
    const { codeVerifier, codeChallenge } = await this.generateCodeChallenge();
    localStorage.setItem('code_verifier', codeVerifier);
    const params = {
      client_id: environment.azureSSO.clientId,
      response_type: 'code',
      redirect_uri: environment.azureSSO.redirectUri,
      scope: environment.azureSSO.scopes.join(' '),
      response_mode: 'query',
      login_hint: email,
      state: uuid(), // You can use a random string or a nonce for security
      code_challenge_method: 'S256', // Use S256 for PKCE
      code_challenge: codeChallenge,
    };
    return `${url}?${new URLSearchParams(params).toString()}`;
  }

  claimSSOToken(code: string, codeVerifier: string, state: string) {
    const url = `${environment.azureSSO.authority}/oauth2/v2.0/token`;
    const formData = new FormData();
    formData.append('client_id', environment.azureSSO.clientId);
    formData.append('scope', environment.azureSSO.scopes.join(' '));
    formData.append('grant_type', 'authorization_code');
    formData.append('redirect_uri', environment.azureSSO.redirectUri);
    formData.append('code', code);
    formData.append('state', state);
    formData.append('code_verifier', codeVerifier);
    return this.httpClient.post(url, formData);
  }

  private async generateCodeChallenge() {
    const codeVerifier = this.generateCodeVerifier();
    const buffer = await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(codeVerifier),
    );
    const byteArray = new Uint8Array(buffer);
    const hash = Array.from(byteArray, (byte) =>
      String.fromCodePoint(byte),
    ).join('');

    const codeChallenge = btoa(hash)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
    return { codeVerifier, codeChallenge };
  }

  private generateCodeVerifier() {
    const randomString = Array.from(
      crypto.getRandomValues(new Uint8Array(32)),
      (byte) => String.fromCodePoint(byte),
    ).join('');
    return btoa(randomString)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }
}
